module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "id": "yjfk"
    }
  }, [_c('header', {
    staticClass: "am-topbar"
  }, [_c('OffCanvas', {
    staticClass: "meun"
  }, [_vm._v("边侧栏")]), _vm._v(" "), _vm._m(0)], 1), _vm._v(" "), _c('div', {
    staticClass: "wrapper"
  }, [_c('div', {
    staticClass: "title"
  }, [_vm._v("尊敬的客户您好：")]), _vm._v(" "), _c('div', {
    staticClass: "text"
  }, [_vm._v("您对我们的新版网站还满意吗？我们很乐意听到您的意见，并会认真对待您的反馈，请您详细描述，以保证管理员及时判断并作出处理。感谢您的关注与支持！")]), _vm._v(" "), _c('div', {
    staticClass: "title"
  }, [_vm._v("您觉得不满意的地方(最多300字符)")]), _vm._v(" "), _c('textarea', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.bmy),
      expression: "bmy"
    }],
    attrs: {
      "rows": "3"
    },
    domProps: {
      "value": (_vm.bmy)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.bmy = $event.target.value
      }
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "title"
  }, [_vm._v("您最常用的功能/最关注的功能(最多300字符)")]), _vm._v(" "), _c('textarea', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.cygz),
      expression: "cygz"
    }],
    attrs: {
      "rows": "3"
    },
    domProps: {
      "value": (_vm.cygz)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.cygz = $event.target.value
      }
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "title"
  }, [_vm._v("您觉得需要增加的功能(最多300字符)")]), _vm._v(" "), _c('textarea', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.gnyj),
      expression: "gnyj"
    }],
    attrs: {
      "rows": "3"
    },
    domProps: {
      "value": (_vm.gnyj)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.gnyj = $event.target.value
      }
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "title"
  }, [_vm._v("其他意见(最多300字符)")]), _vm._v(" "), _c('textarea', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.qtyj),
      expression: "qtyj"
    }],
    attrs: {
      "rows": "3"
    },
    domProps: {
      "value": (_vm.qtyj)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.qtyj = $event.target.value
      }
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "yzm"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.yzm),
      expression: "yzm"
    }],
    attrs: {
      "type": "text",
      "placeholder": "输入验证码"
    },
    domProps: {
      "value": (_vm.yzm)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.yzm = $event.target.value
      }
    }
  }), _vm._v(" "), _c('img', {
    attrs: {
      "title": "点击更换",
      "id": "refreshCodeId",
      "onclick": "$(this).attr('src', '/imageServlet?t=' + Math.random());",
      "src": "/imageServlet?t=0.8820587174216004"
    }
  }), _vm._v(" "), _c('button', {
    attrs: {
      "type": "button"
    },
    on: {
      "click": _vm.submit
    }
  }, [_vm._v("提交反馈")])])]), _vm._v(" "), _c('ICP'), _vm._v(" "), _c('alert', {
    attrs: {
      "showModal": _vm.showAlert
    },
    on: {
      "update:showModal": function($event) {
        _vm.showAlert = $event
      }
    }
  }, [_vm._v(_vm._s(_vm.alertMessage))])], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "logo-wrapper"
  }, [_c('div', {
    staticClass: "title"
  }, [_vm._v("意见反馈")])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-2ff9c8f6"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/page/yjfk/yjfk.vue
// module id = 875
// module chunks = 2